<template>
  <el-container class="bodybox">
    <el-header>
      <header-menu active="setting" />
    </el-header>
    <el-main class="mainbox" v-loading="boxloading">
      <div class="indexbox">
        <p class="tit">Customer：</p>
        <el-form ref="forma" :model="form" :rules="rules" label-width="200px">
          <el-form-item label="API Account" prop="api_account1">
            <el-input v-model="form.api_account1"></el-input>
          </el-form-item>
          <el-form-item label="API Key" prop="api_key1">
            <el-input v-model="form.api_key1"></el-input>
          </el-form-item>
          <el-form-item label="SupplierName" prop="supplier_name">
            <el-input v-model="form.supplier_name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search" @click.native.prevent="onSubmita" :loading='loading'>UPDATE</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="indexbox">
        <p class="tit">Supplier：</p>
        <el-form ref="formb" :model="formb" :rules="rulesb" label-width="200px">
          <el-form-item label="API Account" prop="api_account2">
            <el-input v-model="formb.api_account2"></el-input>
          </el-form-item>
          <el-form-item label="API Key" prop="api_key2">
            <el-input v-model="formb.api_key2"></el-input>
          </el-form-item>
          <el-form-item label="CustomerName" prop="customer_name">
            <el-input v-model="formb.customer_name"></el-input>
          </el-form-item>
          <el-form-item label="Tax Rule" prop="tax_rule">
            <el-input v-model="formb.tax_rule"></el-input>
          </el-form-item>
          <!-- <el-form-item label="CurrencyRate" prop="currency_rate">
            <el-input v-model="formb.currency_rate"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button class="search" @click.native.prevent="onSubmitb" :loading='loadingb'>UPDATE</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="indexbox">

        <div class="searchbox">
          <p class="tit">monthly settlement exchange rate：</p>
          <div class="box">

            <el-button class="search" @click="handleAdd" :loading="loadingb">New</el-button>
          </div>
        </div>
        <div class="tablebox">
          <div class="draggable" v-loading="loading">
            <el-table :data="tableData">
              <el-table-column prop="period" label="AccoutingPeriod" min-width="160" show-overflow-tooltip
                align="center">

              </el-table-column>


              <el-table-column prop="currency" label="Currency" min-width="220" show-overflow-tooltip align='center'>

              </el-table-column>
              <el-table-column prop="currency_rate" label="CurrencyRate" min-width="180" show-overflow-tooltip
                align='center'>

              </el-table-column>

              <el-table-column prop="" label="Operation" min-width="100" align='center'>
                <template slot-scope="scope">
                  <el-button size="mini" class="edit" @click="handleEdit(scope.row)">Edit</el-button>
                  <el-button size="mini" class="delete" @click="handleDelete(scope.row)">Delete</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination @current-change="pagechage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="page_size" background layout="total,sizes,prev, pager, next" :current-page.sync="page"
            :total="total" />
        </div>
      </div>

      <!-- ****************************************************** -->
      <!-- ****************** 核心：新增弹窗代码 ****************** -->
      <!-- ****************************************************** -->
      <!--
  :visible.sync 控制显示隐藏
  @close 事件用于重置表单（可选）
-->
      <el-dialog :key="dialogKey" :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="resetForm">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="160px">
          <!-- Period 字段 -->
          <el-form-item label="Accounting Period" prop="period">
            <!-- <el-input v-model="dialogForm.period" placeholder="YYYY-MM"></el-input> -->
            <el-date-picker v-model="dialogForm.period" type="month" format="yyyy-MM" value-format="yyyy-MM"
              placeholder="Select Month" style="width: 100%;" popper-class="my-date-picker">
            </el-date-picker>
          </el-form-item>
          <!-- Currency 字段 -->
          <el-form-item label="Currency" prop="currency">
            <el-input v-model="dialogForm.currency"></el-input>
          </el-form-item>
          <!-- Currency Rate 字段 -->
          <el-form-item label="Currency Rate" prop="currency_rate">
            <el-input v-model="dialogForm.currency_rate"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">Confirm</el-button>
        </div>
      </el-dialog>

    </el-main>
  </el-container>
</template>
<script>
  import HeaderMenu from "@/components/HeaderMenu"
  export default {
    components: { HeaderMenu },
    data() {
      return {
        boxloading: false,
        form: {
          api_account1: '',
          api_key1: '',
          supplier_name: ''
        },
        rules: {
          api_account1: [{ required: true, trigger: "blur", message: 'Please Provide a  API Account' }],
          api_key1: [{ required: true, trigger: "blur", message: 'Please Provide a  API Key' }],
          supplier_name: [{ required: true, trigger: "blur", message: 'Please Provide a  SupplierName' }],
        },
        loading: false,
        formb: {
          api_account2: '',
          api_key2: '',
          customer_name: '',
          tax_rule: '',
          currency_rate: '',
        },
        rulesb: {
          api_account2: [{ required: true, trigger: "blur", message: 'Please Provide a  API Account' }],
          api_key2: [{ required: true, trigger: "blur", message: 'Please Provide a  API Key' }],
          customer_name: [{ required: true, trigger: "blur", message: 'Please Provide a  Customer Name' }],
          tax_rule: [{ required: true, trigger: "blur", message: 'Please Provide a  Tax Rule' }],
          currency_rate: [{ required: true, trigger: "blur", message: 'Please Provide a  CurrencyRate' }],
        },
        loadingb: false,
        total: 0,
        page: 1,
        page_size: 100,
        tableData: [],

        // 弹窗相关
        dialogVisible: false, // 控制弹窗显示/隐藏
        dialogKey: 0, // <--- 加上这一行
        dialogTitle: 'Add', // 弹窗标题
        isEdit: false, // 标记当前是编辑状态还是新增状态
        submitLoading: false, // 提交按钮的 loading 状态

        // 弹窗表单数据
        dialogForm: {
          id: null, // 编辑时需要传 ID，新增时为空
          period: '',
          currency: '',
          currency_rate: ''
        },

        // 弹窗表单的校验规则
        dialogRules: {
          period: [{ required: true, message: 'Please input period', trigger: 'blur' }],
          currency: [{ required: true, message: 'Please input currency', trigger: 'blur' }],
          currency_rate: [{ required: true, message: 'Please input rate', trigger: 'blur' }]
        }
      }
    },
    created() {
      this.get_info()
      this.get_list()
    },
    methods: {
      get_info() {
        this.boxloading = true
        this.$get({
          url: "/config/find",
          success: (res) => {
            this.form = {
              api_account1: res.data.api_account1,
              api_key1: res.data.api_key1,
              supplier_name: res.data.supplier_name,
            }
            this.formb = {
              api_account2: res.data.api_account2,
              api_key2: res.data.api_key2,
              customer_name: res.data.customer_name,
              tax_rule: res.data.tax_rule,
              currency_rate: res.data.currency_rate,
            }
            setTimeout(() => {
              this.boxloading = false
            }, 200)
          },
          tip: () => {
            this.boxloading = false
          },
        })
      },
      onSubmita() {
        this.$refs.forma.validate(valid => {
          if (valid) {
            this.loading = true
            this.$post({
              url: "/config/customerSet",
              data: this.form,
              success: (res) => {
                this.$message({ message: 'Success', type: 'success' });
                // this.form = { api_account1: '', api_key1: '', supplier_name: '' }
                setTimeout(() => { this.loading = false }, 500);
                this.getlist()
              },
              tip: () => {
                setTimeout(() => { this.loading = false }, 500);
              },
            })
          }
        })
      },
      onSubmitb() {
        this.$refs.formb.validate(valid => {
          if (valid) {
            this.loadingb = true
            this.$post({
              url: "/config/supplierSet",
              data: this.formb,
              success: (res) => {
                this.$message({ message: 'Success', type: 'success' });
                // this.formb = { api_account2: '', api_key2: '', customer_name: '', tax_rule: '', currency_rate: '' }
                setTimeout(() => { this.loadingb = false }, 500);
                this.getlist()
              },
              tip: () => {
                setTimeout(() => { this.loadingb = false }, 500);
              },
            })
          }
        })
      },
      get_list() {
        this.loading = true
        this.$get({
          url: "/currencyRate/index",
          data: {
            page: this.page,
            page_limit: this.page_size,
            date: this.date,

          },
          success: (res) => {
            this.tableData = res.data.data
            this.total = res.data.total
            setTimeout(() => {
              this.loading = false
            }, 200)
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.get_list()
      },
      handleSizeChange(size) {
        this.page_size = size
        this.tableData = []
        this.get_list()
      },
      reSync() {
        this.loadingb = true
        this.$get({
          url: "/reSync",
          success: (res) => {
            this.loadingb = false
            this.pagechage(1)
          },
          tip: () => { this.loadingb = false },
        })
      },
      change(data) {
        this.loading = true
        this.$get({
          url: "/reSyncErrorLog",
          data: { id: data.id },
          success: (res) => {
            this.pagechage(1)
          },
          tip: () => { this.loadingb = false },
        })
      },

      // 1. 处理新增
      handleAdd() {
        this.dialogTitle = 'Add Record';
        this.dialogForm = {
          id: null, // 编辑时需要传 ID，新增时为空
          period: '',
          currency: '',
          currency_rate: ''
        }
        this.isEdit = false; // 标记为新增
        this.dialogVisible = true;
        // 新增时清空表单，或者可以预设默认值
        // this.dialogForm 已经在 data 里定义为空了
      },

      // 2. 处理编辑
      handleEdit(row) {


        this.dialogTitle = 'Edit Record';
        this.isEdit = true; // 标记为编辑
        // 将当前行的数据赋值给弹窗表单
        // 注意：这里不能直接引用，否则会双向绑定修改原表格数据，建议深拷贝或赋值
        this.dialogForm = JSON.parse(JSON.stringify(row));// 展开运算符复制一份数据
        this.dialogVisible = true;
      },

      // 3. 处理删除 (带确认)
      handleDelete(row) {
        this.$confirm('This action will delete the record. Continue?', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          // 关键代码：给确认按钮和取消按钮挂载自定义 Class
          customClass: 'my-custom-confirm',
        }).then(() => {
          // 这里写你的删除接口调用
          // 假设接口是 /currencyRate/delete
          this.$post({
            url: "/currencyRate/destroy",
            data: { id: row.id }, // 传 ID 给后端
            success: (res) => {
              this.$message.success('Deleted successfully');
              // 删除成功后，刷新表格列表
              this.get_list(); // 调用你原来的获取列表方法
            },
            error: (err) => {
              this.$message.error('Delete failed');
            }
          });
        }).catch(() => {
          this.$message.info('Delete canceled');
        });
      },

      // 4. 提交表单 (新增或更新)
      submitForm() {
        this.$refs.dialogForm.validate((valid) => {
          if (valid) {
            this.submitLoading = true;

            // 判断是新增还是编辑
            let url = this.isEdit ? "/currencyRate/update" : "/currencyRate/add";

            this.$post({
              url: url,
              data: this.dialogForm, // 直接发送 dialogForm 数据
              success: (res) => {
                this.$message.success(this.isEdit ? 'Update success' : 'Add success');
                this.dialogVisible = false; // 关闭弹窗
                this.get_list(); // 刷新表格数据
                this.submitLoading = false;
              },
              tip: (err) => {
                this.$message.error('Operation failed');
                this.submitLoading = false;
              },

            });
          }
        });
      },

      // 5. 重置表单 (当关闭弹窗时，清空输入内容，防止下次打开还留着旧数据)
      resetForm() {
        console.log('更新++')

        this.dialogKey++;
        // 1. 先手动重置数据对象，确保数据是干净的（解决 resetFields 记忆旧数据的问题）
        this.dialogForm = {
          id: null,
          period: '',
          currency: '',
          currency_rate: ''
        };

        // 2. 等待 DOM 更新后，再清除校验状态（红框）
        this.$nextTick(() => {
          if (this.$refs.dialogForm) {
            this.$refs.dialogForm.resetFields();
          }
        });
      }
    },
  }
</script>
<style lang="scss" scoped>
  .mainbox {
    padding: 20px !important;
    .indexbox {
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 30px 50px 10px;
      margin-bottom: 30px;
      border-radius: 4px;
      .tit {
        width: 100%;
        font-size: 14px;
        color: #3b3b3b;
        font-weight: 550;
        padding-bottom: 20px;
      }
      /deep/.el-button {
        border-radius: 10px;
        color: #3b3b3b;
        font-size: 16px;
      }
      .search {
        width: 100%;
        height: 40px;
        background: #d6f3e3;
        border-color: #d6f3e3;
        &:hover {
          color: #606266;
        }
      }
    }
  }
  .searchbox {
    width: 100%;
    // padding: 10px 0 0 20px;
    background: #fff;
    border-bottom: 1px solid #babdcd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .tit {
      width: auto !important;
    }
    .box {
      padding: 0 0 10px 0;
    }
    .small {
      width: 130px;
    }
    .inp {
      width: 300px;
      /deep/.el-input__inner {
        background: #edeff8;
      }
    }
    /deep/.el-button {
      border-radius: 10px;
      color: #3b3b3b;
      font-size: 16px;
    }
    .search {
      background: #d6f3e3;
      border-color: #d6f3e3;
    }
    .reset {
      background: #f3d6d6;
      border-color: #f3d6d6;
    }
  }
  .edit {
    background: #d6f3e3;
    border-color: #d6f3e3;
  }
  .delete {
    background: #f3d6d6;
    border-color: #f3d6d6;
  }
  /* 深度作用选择器，穿透 scoped 样式，修改弹窗内部的默认按钮 */
  ::v-deep .el-dialog {
    .el-button {
      border-radius: 10px;
      /* 保持和项目其他按钮一致 */
      font-size: 16px;
      /* 保持字体大小一致 */
    }
    /* 确认按钮：应用项目中的“搜索/编辑”颜色 */
    .el-button--primary {
      background: #d6f3e3;
      border-color: #d6f3e3;
      color: #3b3b3b;
      /* 文字颜色保持深色 */
      &:hover {
        background: darken(#d6f3e3, 5%);
        /* 鼠标悬停稍微加深一点，增加反馈 */
        border-color: darken(#d6f3e3, 5%);
      }
    }
    /* 取消按钮：应用项目中的“重置/删除”对比色或中性色 */
    /* 注意：不要用红色做取消，容易误点。这里建议用灰色或你的青绿色边框 */
    .el-button:first-child {
      background: #fff;
      /* 白色背景 */
      border: 1px solid #d6f3e3;
      /* 青绿色边框 */
      color: #3b3b3b;
    }
  }
</style>
